// extracted by mini-css-extract-plugin
export default {"valueContainer":"Value_valueContainer__C+Izt","valueContent":"Value_valueContent__Hmg0l","borderRight":"Value_borderRight__JBoZ7","valueText":"Value_valueText__7I9Py"};